function productcarousel(){
  var productslider=[];
  document.querySelectorAll('.product-carousel').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.carousel-rowouter');
    let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let pagination = outer_carousel.querySelectorAll('.swiper-pagination')[0];
    let swiperObject = {
      loop: eval(Element.dataset.loop),
      slidesPerGroup: 1,
      slidesPerView: "auto",
      pagination: {
        el: pagination,
        type: 'progressbar',
      },
      navigation: {
        nextEl: nextbutton,
        prevEl: prevbutton,
      },
      breakpoints: {
        500: {
          slidesPerGroup: 2,
        },
        768: {
          slidesPerGroup: 3,
        },
        1024: {
          slidesPerGroup: 4,
        },
      }
    };
    productslider[productid]=new Swiper(Element,swiperObject);
  });
}
productcarousel();
function arrowCenter(){
  let height = document.querySelector('.carousel-row .grid-imagebox .product-images').offsetHeight / 2
  document.querySelectorAll('.carousel-rowouter .swiper-button').forEach((arrows) => {
    arrows.style.top = height + 'px'
  })
}
addEventListener("DOMContentLoaded", arrowCenter);
addEventListener("resize", arrowCenter);